import { render, staticRenderFns } from "./ModalitySwitch.vue?vue&type=template&id=5e48ac62&scoped=true&"
import script from "./ModalitySwitch.vue?vue&type=script&lang=ts&"
export * from "./ModalitySwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ModalitySwitch.vue?vue&type=style&index=0&id=5e48ac62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48ac62",
  null
  
)

export default component.exports